module.exports = __webpack_public_path__ + "img/14_1.060517cc.png";